export default __webpack_public_path__ + "static/media/player_play.8feda5db.svg";